<template>
  <el-menu :default-active="selfActiveTab"
    class="menu" mode="horizontal"
    @select="select"
    >
    <el-menu-item v-for='(item,index) in menuTab' :key='index'
      :index="index.toString()"
      class='menu-item'
      :class='{choose: index.toString() == selfActiveTab}'>
      {{item}}
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  props: {
    activeTab: String,
    menuTab: Array,
  },
  data() {
    return {
      selfActiveTab: this.activeTab
    }
  },
  methods: {
    select(index){
      this.$emit('change',index)
      this.selfActiveTab = index
    }
  },
  watch: {
    activeTab: function() {
      this.selfActiveTab = this.activeTab
    }
  },
};
</script>

<style lang="stylus" scoped>
.menu {
  // height: 1rem;
  .menu-item {
    font-size: 0.26rem;
    height: 100%;
    line-height: 1rem;
    color: #707070;
  }
  .choose {
    color: #333333;
    border-bottom: 2px solid #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/NavMenu.vue